import { useEffect } from "react";
import { useSignout } from "services/authUtil";
import "./auth.css";

/**
 * This component signs the user out when rendered.
 */
export default function SignOut() {
  const signOut = useSignout();
  useEffect(() => {
    signOut();
  }, [signOut]);

  return null;
}
